import React from "react";
import { useTranslation } from "react-i18next";
import {
  isRegistrationOpen,
  isSubmissionOpen,
} from "../../utils/tinkerpreneur";

const ATLTinkerpreneurCTA = ({ year }) => {
  const { t } = useTranslation();
  const registrationOpen = isRegistrationOpen(year);
  const submissionOpen = isSubmissionOpen(year);
  const accessToken = localStorage.getItem("jwtToken");
  return (
    <div className="d-flex align-items-center flex-column mt-5">
      <div
        className="d-flex align-items-center flex-wrap justify-content-center"
        style={{ gap: "1rem" }}
      >
        {registrationOpen && !accessToken ? (
          <a
            href="/signup?source=tinkerpreneur-2026"
            className="btn-theme-primary text-white text-decoration-none text-nowrap px-4 py-3"
          >
            {t("atl_tinkerpreneur.cta_button")}
          </a>
        ) : !registrationOpen && !submissionOpen ? (
          <button
            disabled
            className="btn-theme-primary text-white text-nowrap px-4 py-3"
            style={{ opacity: 0.6, cursor: "not-allowed" }}
          >
            Registrations closed
          </button>
        ) : null}
        <a
          href={
            year === 2026
              ? "https://drive.google.com/file/d/1kkTgOcZSe797IV2S04c42OqOce9ZXp4s/view"
              : "https://drive.google.com/file/d/1oOppGgPnwpBBSHNFS1woO-w313biy1TW/view"
          }
          className="btn-theme-primary text-white text-decoration-none text-nowrap px-4 py-3"
          style={{ background: "#ff8f4e" }}
          target="_blank"
          rel="noreferrer"
        >
          PARTICIPATION HANDBOOK
        </a>
        {submissionOpen && accessToken ? (
          <a
            href={`/tinkerpreneur-${year}/submission`}
            className="btn-theme-primary text-white text-decoration-none text-nowrap px-4 py-3"
          >
            SUBMIT PROJECT
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default ATLTinkerpreneurCTA;
